import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { Home } from './pages/Home';
import { Programs } from './pages/Programs';
import { ProgramDetail } from './pages/ProgramDetail';
import { Shop } from './pages/Shop';
import { ProductDetail } from './pages/ProductDetail';
import { HowItWorks } from './pages/HowItWorks';
import { Labs } from './pages/Labs';
import { Pricing } from './pages/Pricing';
import { About } from './pages/About';
import { GetStarted } from './pages/GetStarted';
import { BrandProvider } from './contexts/BrandContext';
interface AppProps {
  /** Which client brand the template renders. Adding a brand is a theme entry, not a fork. */
  brand?: 'republic' | 'verdant';
}
export function App({
  brand = 'republic'
}: AppProps) {
  return <BrandProvider brandId={brand} data-id="element-0" data-mp="23w4clvc6cty7">
      <BrowserRouter data-id="element-1" data-mp="23v2tr4ox335x">
        <ScrollToTop data-id="element-2" data-mp="3ijxpcqos80jw" />
        <div className="flex min-h-screen w-full flex-col bg-cream" data-id="element-3" data-mp="3ikha0f5th31m">
          <Header data-id="element-4" data-mp="3ii4r9zs8ioni" />
          <Routes data-id="element-5" data-mp="3mlax56bfqdtg">
            <Route path="/" element={<Home data-id="element-7" data-mp="3mjzs7369700r" />} data-id="element-6" data-mp="3mkrcviybbdc9" />
            <Route path="/programs" element={<Programs data-id="element-9" data-mp="3rbr9en3irte8" />} data-id="element-8" data-mp="3mjg8pi0yg3km" />
            <Route path="/programs/:slug" element={<ProgramDetail data-id="element-11" data-mp="3recbnd7qcbci" />} data-id="element-10" data-mp="3rdatypw7kqlt" />
            <Route path="/shop" element={<Shop data-id="element-13" data-mp="4n4pyuukj8z" />} data-id="element-12" data-mp="6hrlipoilfp" />
            <Route path="/shop/:slug" element={<ProductDetail data-id="element-15" data-mp="2zld0z6e9z99y" />} data-id="element-14" data-mp="56l3b4umzkw" />
            <Route path="/how-it-works" element={<HowItWorks data-id="element-17" data-mp="2zn6aquk6q9m6" />} data-id="element-16" data-mp="2zm4wyibsb90r" />
            <Route path="/labs" element={<Labs data-id="element-19" data-mp="33nq73vwxp979" />} data-id="element-18" data-mp="33mf2jtvnzxf3" />
            <Route path="/pricing" element={<Pricing data-id="element-21" data-mp="33oi0d0326uud" />} data-id="element-20" data-mp="33n6wz1dizp3s" />
            <Route path="/about" element={<About data-id="element-23" data-mp="38l06a3a4kz8a" />} data-id="element-22" data-mp="38l8hlqqlnwhd" />
            <Route path="/get-started" element={<GetStarted data-id="element-25" data-mp="3dkl0y1i9ilf7" />} data-id="element-24" data-mp="38nuodo5o27yj" />
            <Route path="*" element={<Home data-id="element-27" data-mp="3dm60k5jfoujx" />} data-id="element-26" data-mp="3dlntedv8gvx8" />
          </Routes>
          <Footer data-id="element-28" data-mp="nvssr1axyhud" />
        </div>
      </BrowserRouter>
    </BrandProvider>;
}
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0
    });
  }, [pathname]);
  return null;
}